import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { CheckoutRequests } from "./checkoutRequests.type";

/**
 * Initial state object
 */
const initialState: CheckoutRequests = {
     data: [],
};

const url = process.env.REACT_APP_API_URL;

const getCheckoutRequests = createAsyncThunk(
  "checkoutRequests/getCheckoutRequests",
  async (arg: void, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/checkout/get/requests`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    const params = {
      dateFrom: new Date(),
      dateTo: new Date(),
    };
    
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), params, { headers })
      );
      console.log("Success response from checkout logs :", response.data);
      dispatch(checkoutRequestsActions.setData(response.data));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const searchCheckoutRequests = createAsyncThunk(
  "checkoutRequests/searchCheckoutRequests",
  async (arg: any, { rejectWithValue, getState, dispatch }: any) => {
    const pathname = `/checkout/get/requests/search`;
    const token = getState().login.token;
    const headers = {
      "x-auth-token": token,
    };
    const params = {
      dateFrom: arg.from,
      dateTo: arg.to,
    };
    try {
      /** make api call */
      const response = await trackPromise(
        axios.post(url!.concat(pathname), params, { headers })
      );
      console.log("Success response from loan requests :", response.data);
      dispatch(checkoutRequestsActions.setData(response.data));
      return response.data;
    } catch (e: any) {
      console.error(e);
      return rejectWithValue(e.response?.data);
    }
  }
);

const checkoutRequestsSlice = createSlice({
 
  name: "checkoutRequests",

  initialState: initialState,

  reducers: {
    setCheckoutRequests: (state, action) => {
      return { ...state, ...action.payload };
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    reset: () => initialState,
    // Add here reducers
    // ...
  },

});

export const checkoutRequestsReducer = checkoutRequestsSlice.reducer;

export const checkoutRequestsActions = { ...checkoutRequestsSlice.actions, getCheckoutRequests, searchCheckoutRequests };
